import { ReviewContent } from '~commons/types';

export const getReviewImageCount = (review: { content: ReviewContent }) =>
  review.content.media.filter((m) => 'image' in m).length;

export const getReviewVideoCount = (review: { content: ReviewContent }) =>
  review.content.media.filter((m) => 'video' in m).length;
